import { useState } from "react";
import { useTranslation } from "react-i18next";
import SideBarPlayersList from "./SideBarPlayersList";

const SideOptionFacilitator = () => {
    const { t } = useTranslation();
    const [isSideOptionShown, setIsSideOptionShown] = useState<boolean>(true);
    const sideOptionBoxPositioning: string = isSideOptionShown ? "show_side_option" : "hide_side_option";

    const toggleArrow = () => {
        return(
            <div className="toggle_arrow_wrapper" onClick={() => setIsSideOptionShown(!isSideOptionShown)}>
                {isSideOptionShown? <div> {t("hideMeText")} </div> : <div> {t("showMeText")} </div> }
            </div>
        )
    }

    const sideOptionBox = () => {
        return (
            <div className="side_option_box_wrapper">
                <SideBarPlayersList />
            </div>
        )
    }

    return (
        <div className={`side_option_facilitator_wrapper ${sideOptionBoxPositioning}`}>
            {sideOptionBox()}
            {toggleArrow()}
        </div>
    )
}

export default SideOptionFacilitator; 